import { createBrowserRouter, Outlet } from 'react-router';
import { AppAuthProvider } from '../components/loginSignup/AppAuthProvider';
import PageLayout from '../components/PageLayout';
import { publicRoutes } from './routes/publicRoutes';
import { AuthenticatedLayout } from './layouts/AuthenticatedLayout';
import { appRoutes } from './routes/appRoutes';
import { errorRoutes } from './routes/errorRoutes';
import AuthenticatedRoute from '../components/AuthenticatedRoute';
import AccountSetupPage from '../components/accountSetup/AccountSetupPage';

export const AppRouter = createBrowserRouter([
  {
    path: '/',
    element: (
      <AppAuthProvider>
        <PageLayout />
      </AppAuthProvider>
    ),
    children: [
      ...publicRoutes,
      {
        element: <AuthenticatedRoute><Outlet /></AuthenticatedRoute>,
        children: [{ path: 'account-setup', element: <AccountSetupPage /> }],
      },
      {
        element: <AuthenticatedLayout />,
        children: [...appRoutes],
      },
            
      ...errorRoutes
    ]
  }
]);
